module.exports = __webpack_public_path__ + "img/cell_size_3.de07bc11.svg";